var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, computed, makeObservable } from 'mobx';
import _get from 'lodash/get';
import _set from 'lodash/set';
import _merge from 'lodash/merge';
// TODO: do not import forms into mobx store. NO. PLEASE, GOD NO!
import form from '../components/pages/VehicleDetailedPage/ContactForm/ContactFormConfig';
import UserActionsAPI from '../services/UserActionsAPI';
import UserActionsContactAPI from '../services/UserActionsContactAPI';
import CarsAPI from '../services/CarsAPI';
import { ShowNotificationError } from '../framework/ErrorLogger';
import { transformDataForVehicles } from '../framework/DataTransformers';
import { MODULE_SURFACE, PAGE_TYPE } from '../framework/constants/tracking';
import AuthStore from './AuthStore';
import AlternativeCarsAPI from '../services/AlternativeCarsAPI';
import FinancingStore from './FinancingStore';
import { getComputedFinancing } from '@bytebrand/fe-financing';
class VehicleDetailsStore {
    constructor() {
        Object.defineProperty(this, "car", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "isFetching", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "contactFormIsFetching", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "isAvailable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "sellingStatusLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "updateCarStatusLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "updateShowDownPayment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "captcha", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "formStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "selectedDamageUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "comparableCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "copyCarForDealer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId, newData) => UserActionsAPI.copyCarForDealer(carId, newData)
        });
        Object.defineProperty(this, "setMarkCarAsNew", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId) => CarsAPI.setMarkCarAsNew(carId)
        });
        Object.defineProperty(this, "getCar", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, withJWT) => {
                const API = window.location.pathname.includes('alternative') ? AlternativeCarsAPI : CarsAPI;
                return API.getCarData(id, withJWT)
                    .then((response) => {
                    this.isFetching = false;
                    const rawFirstInstallment = _get(response, 'rate.firstInstallment', null);
                    const transformedVehicle = FinancingStore.normalizeRateObject(response);
                    _set(transformedVehicle, 'rate.rawFirstInstallment', rawFirstInstallment);
                    return this.car = transformedVehicle;
                })
                    .catch((error) => {
                    // TODO: error handling
                    this.isAvailable = false;
                });
            }
        });
        Object.defineProperty(this, "importAlternative", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId, data) => {
                return AlternativeCarsAPI.importAlternative(carId, data)
                    .then((data) => _get(data, '_id'))
                    .catch((error) => {
                    console.log(`error data._id = `, error);
                });
            }
        });
        Object.defineProperty(this, "getAlternativeCarImages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, withJWT) => {
                return AlternativeCarsAPI.getAlternativeCarImages(id, withJWT)
                    .then(({ images }) => {
                    this.isFetching = false;
                    return Array.isArray(images) ? images : [];
                })
                    .catch((error) => {
                    console.log(`error getAlternativeCarImages = `, error);
                    this.isAvailable = false;
                    return [];
                });
            }
        });
        Object.defineProperty(this, "updateRecommendationCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.comparableCars.forEach((car, i) => {
                    // Per-car adjustments: recompute only cars the user adjusted themselves;
                    // all other comparable cars keep their dealer defaults.
                    const carAdjustments = FinancingStore.getUserCarAdjustments(car.id);
                    if (!Object.keys(carAdjustments).length)
                        return;
                    const newConfig = _merge(car.price, carAdjustments);
                    const mlCurrentSalesPricePredicted = car.price.mlCurrentSalesPricePredicted;
                    const price = { ...getComputedFinancing(newConfig), mlCurrentSalesPricePredicted };
                    this.comparableCars[i].price = price;
                });
            }
        });
        Object.defineProperty(this, "getRecommendationCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carId, t) => {
                if (AuthStore.isAlternative) { // disable recommendations if on alternative portal
                    this.comparableCars = observable([]);
                }
                else {
                    UserActionsAPI.getRecommendationCars(carId)
                        .catch(({ errors }) => {
                        console.log('errors', errors);
                        if ((Array.isArray(errors) && errors[0].id === 'BadRequestError') ||
                            errors[0].title === 'No car with provided ID found' ||
                            errors[0].title === `Car ${carId} not exists`) {
                            UserActionsAPI.getPublicRecommendation(PAGE_TYPE.VEHICLE_DETAIL_PAGE, MODULE_SURFACE.SIMILAR_CARS)
                                .then((cars) => {
                                console.log('cars getPublicRecommendation = ', cars);
                                for (let i = 0; i < cars.length; i++) {
                                    this.comparableCars.push(transformDataForVehicles(cars[i], t, true));
                                }
                            })
                                .catch(err => {
                                // similar/recommended cars are a non-critical section — fail silently (no error toast)
                                console.log('cars getPublicRecommendation =  = ', err);
                            });
                        }
                        return Promise.reject(errors);
                    })
                        .then((data) => {
                        if (data.length === 0) {
                            UserActionsAPI.getPublicRecommendation(PAGE_TYPE.VEHICLE_DETAIL_PAGE, MODULE_SURFACE.SIMILAR_CARS)
                                .then((cars) => {
                                for (let i = 0; i < cars.length; i++) {
                                    this.comparableCars.push(transformDataForVehicles(cars[i], t));
                                }
                            });
                        }
                        for (let i = 0; i < data.length; i++) {
                            this.comparableCars.push(transformDataForVehicles(data[i], t));
                        }
                    })
                        .catch(err => {
                        // similar/recommended cars are a non-critical section — fail silently (no error toast)
                        console.log('loadRecommendations = ', err);
                    });
                }
            }
        });
        /**
         * ADV-302 — recommendations for the unavailable/deleted-vehicle state. Deliberately calls
         * getPublicRecommendation directly instead of getRecommendationCars(carId): the car behind
         * carId doesn't exist, so there is no "similar to THIS car" signal to request, and for a
         * logged-in user car/:id/recommendation does NOT 404 on an unknown id the way it does for a
         * guest — it falls through to a personalized, unbounded list instead of the capped generic
         * one, which is what made the unavailable-page block show far more cards than NotFoundPage's
         * identical "UNSERE TOP-ANGEBOTE FÜR SIE" block (NotFoundStore.getRecommendationCars also
         * always calls getPublicRecommendation directly, regardless of auth state).
         */
        Object.defineProperty(this, "getUnavailableRecommendationCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (t) => {
                if (AuthStore.isAlternative) { // disable recommendations if on alternative portal
                    this.comparableCars = observable([]);
                    return;
                }
                UserActionsAPI.getPublicRecommendation(PAGE_TYPE.VEHICLE_DETAIL_PAGE, MODULE_SURFACE.SIMILAR_CARS)
                    .then((cars) => {
                    for (let i = 0; i < cars.length; i++) {
                        this.comparableCars.push(transformDataForVehicles(cars[i], t));
                    }
                })
                    .catch(err => {
                    // similar/recommended cars are a non-critical section — fail silently (no error toast)
                    console.log('getUnavailableRecommendationCars = ', err);
                });
            }
        });
        Object.defineProperty(this, "setCaptcha", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (captcha) => {
                this.captcha = captcha;
            }
        });
        Object.defineProperty(this, "setFormStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (status) => {
                this.formStatus = status;
            }
        });
        Object.defineProperty(this, "intervalShowMassage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const time = 5000;
                setTimeout(() => {
                    this.setFormStatus('');
                }, time); // eslint-disable-line
            }
        });
        Object.defineProperty(this, "handleStatusChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (status) => {
                this.setFormStatus(status);
                this.intervalShowMassage();
                if (status !== 'error') {
                    form.clear();
                }
            }
        });
        Object.defineProperty(this, "submitForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (request) => {
                this.contactFormIsFetching = true;
                return UserActionsContactAPI.sendingContactForm(request).then(() => {
                    this.contactFormIsFetching = false;
                }).catch((err) => {
                    this.contactFormIsFetching = false;
                    this.handleStatusChange('error');
                    // re-throw so callers (VdpEnquiry) don't show the success screen on a failed POST
                    throw err;
                });
            }
        });
        Object.defineProperty(this, "submitOfferRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (dataObj) => {
                return UserActionsContactAPI.requestOffer(dataObj)
                    .then((data) => {
                    return data;
                })
                    .catch((err) => {
                    ShowNotificationError();
                    // re-throw (like submitOfferRequestByID) so callers don't fire GTM/success on failure
                    throw err;
                });
            }
        });
        Object.defineProperty(this, "submitOfferRequestForCustomers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (dataObj) => {
                return UserActionsContactAPI.submitOfferRequestForCustomers(dataObj)
                    .then((data) => {
                    return data;
                })
                    .catch((err) => {
                    ShowNotificationError();
                    // re-throw (like submitOfferRequestByID) so callers don't fire GTM/success on failure
                    throw err;
                });
            }
        });
        Object.defineProperty(this, "submitOfferRequestByID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (dataObj, userID) => {
                return UserActionsContactAPI.requestOfferByID(dataObj, userID)
                    .then((data) => {
                    return data;
                })
                    .catch((err) => {
                    ShowNotificationError();
                    throw new Error(err);
                });
            }
        });
        Object.defineProperty(this, "submitContactForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (dataObj) => {
                this.setFormStatus('pending');
                // const captcha = this.captcha;
                // if (!captcha) {
                //   this.handleStatusChange('error');
                // } else {
                return this.submitForm({ ...dataObj });
                // }
            }
        });
        Object.defineProperty(this, "changeSellingStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (status) => {
                // If no status passed, then just take current car status and toggle it to opposite value.
                const newStatus = status !== undefined ? status : !_get(this.car, 'state.isOnline', false);
                const newData = _set({}, 'state.isOnline', newStatus);
                this.sellingStatusLoading = true;
                return CarsAPI.updateCarData(this.carID, { data: newData })
                    .then(() => {
                    this.sellingStatusLoading = false;
                    _set(this.car, 'state.isOnline', newStatus);
                })
                    .catch((err) => {
                    this.sellingStatusLoading = false;
                    ShowNotificationError();
                    return err;
                });
            }
        });
        Object.defineProperty(this, "onUpdateCarDays", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (importBlockedTo) => {
                this.updateCarStatusLoading = true;
                const newData = {};
                if (!!importBlockedTo) {
                    _set(newData, 'metaData.importBlockedTo', null);
                    _set(newData, 'metaData.lockType', null);
                    return CarsAPI.updateCarData(this.carID, { data: newData })
                        .then(() => {
                        this.updateCarStatusLoading = false;
                        _set(this.car, 'metaData.importBlockedTo', null);
                        _set(this.car, 'metaData.lockType', null);
                    })
                        .catch(err => {
                        this.sellingStatusLoading = false;
                        ShowNotificationError();
                    });
                }
                const unixTimestamp = 2147483647;
                _set(newData, 'metaData.importBlockedTo', unixTimestamp);
                _set(newData, 'metaData.lockType', 'complete');
                this.updateCarStatusLoading = true;
                return CarsAPI.updateCarData(this.carID, { data: newData })
                    .then(() => {
                    this.updateCarStatusLoading = false;
                    _set(this.car, 'metaData.importBlockedTo', unixTimestamp);
                    _set(this.car, 'metaData.lockType', 'complete');
                })
                    .catch(err => {
                    this.updateCarStatusLoading = false;
                    ShowNotificationError();
                });
            }
        });
        Object.defineProperty(this, "onChangeShowDownPayment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const NewShowDownPayment = !this.car.offer.showDownPayment;
                const newData = _set({}, 'offer.showDownPayment', NewShowDownPayment);
                _set(newData, 'offer.showDownPaymentLevel', 'car');
                this.updateShowDownPayment = true;
                return CarsAPI.updateCarData(this.carID, { data: newData })
                    .then(() => {
                    this.updateShowDownPayment = false;
                    _set(this.car, 'offer.showDownPayment', NewShowDownPayment);
                })
                    .catch(err => {
                    this.updateShowDownPayment = false;
                    ShowNotificationError();
                });
            }
        });
        Object.defineProperty(this, "clearState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.car = {};
                this.comparableCars.clear();
                this.isAvailable = true;
            }
        });
        Object.defineProperty(this, "setSelectedDamageURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (url) => {
                this.selectedDamageUrl = url;
            }
        });
        makeObservable(this);
    }
    get carID() {
        return _get(this.car, '_id');
    }
    get carName() {
        const make = _get(this.car, 'mainData.make', '');
        const model = _get(this.car, 'mainData.model', '');
        return `${make} ${model}`;
    }
    get carLoaded() {
        return !this.isFetching && !!Object.keys(this.car).length;
    }
    get carSellingStatus() {
        return _get(this.car, 'state.isOnline', false);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "car", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "isFetching", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "contactFormIsFetching", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "isLoading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "isAvailable", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "sellingStatusLoading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "updateCarStatusLoading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "updateShowDownPayment", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "captcha", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "formStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "selectedDamageUrl", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "comparableCars", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], VehicleDetailsStore.prototype, "carID", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], VehicleDetailsStore.prototype, "carName", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], VehicleDetailsStore.prototype, "carLoaded", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], VehicleDetailsStore.prototype, "carSellingStatus", null);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "copyCarForDealer", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "setMarkCarAsNew", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "getCar", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "importAlternative", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "getAlternativeCarImages", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "updateRecommendationCars", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "getRecommendationCars", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "getUnavailableRecommendationCars", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "setCaptcha", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "setFormStatus", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "submitOfferRequest", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "submitOfferRequestForCustomers", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "submitOfferRequestByID", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "submitContactForm", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "changeSellingStatus", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "onUpdateCarDays", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "onChangeShowDownPayment", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "clearState", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleDetailsStore.prototype, "setSelectedDamageURL", void 0);
export default new VehicleDetailsStore();
